<template>
  <div class="c-access-block-edit">
    <div class="block-window">
      <n-card class="block-card">
        <n-loader :loading="$var('load')" />
        <div class="card-top">
          <n-button flat @click="closeModal">X</n-button>
        </div>
        <div>
          <div>
            <h4>Выберите новое время окончания</h4>
            <div class="wrapper">
              <n-input v-bind="$form.input('date')" type="date" />
              <n-input v-bind="$form.input('time')" type="time" />
            </div>
          </div>
          <div class="button-save">
            <n-button color="primary" @click="save">Сохранить</n-button>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CAccessBlockEdit',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    content: '',
  }),
  created() {
    this.$form.init({
      date: '',
      time: '',
    })
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false)
    },
    save() {
      this.$var('load', true)
      this.$form.init({
        endAt: `${this.$form.get('date')} ${this.$form.get('time')}`,
      });
      $api.accessBlocks.edit(this.id, this.$form.get()).then(() => {
        this.closeModal();
        this.notifyParent();
      }).catch((error) => {
        console.error('Ошибка при изменении времени');
      }).finally(() => {
        this.$var('load', false)
      })
    },
    notifyParent() {
      this.$emit('notify');
    }
  },
}
</script>

<style lang="scss" scoped>
.c-access-block-edit {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .block-card {
    min-width: 700px;
    min-height: 300px;
    max-width: 80vw;
  }

  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }

  .card-top {
    display: flex;
    align-items: center;
    justify-content: right;
  }

  .wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
</style>
